import { groupConstants } from '../_constants/group.constants';
import { groupService } from '../_services/group.service';
// import { alertActions } from './alert.actions'

export function getAll() {
  return dispatch => {
    dispatch(request());

    groupService.getAll()
      .then((collection) => {
        dispatch(success(collection));
      })
      .catch((error) => {
        // dispatch(alertActions.error("Could not retrieve groups at this time. Please try again."));
      });
  }

  function request() { return { type: groupConstants.GETALL_GROUPS_REQUEST } }
  function success(collection) { return { type: groupConstants.GETALL_GROUPS_SUCCESS, collection } }
}